import { Typography } from "components/atoms";
import "./index.scss";

interface IProps {
  question: string | undefined;
  // questionNumber: number;
}

export const OnboardingFormQuestion = ({
  question,
  // questionNumber,
}: IProps) => {
  return (
    <div className="onb-form-question-wrapper">
      {/* <Typography
        label={`${questionNumber}`}
        variant="h7Bold"
        styles="custom-question-style"
      /> */}
      {question ? (
        <Typography
          label={question}
          variant="h7Bold"
          styles="custom-question-style"
        />
      ) : null}
    </div>
  );
};
